export default __webpack_public_path__ + "static/media/assets-print.6674a27b.jpg";